import React, { useCallback, useState } from 'react';

import { useMediaQuery } from 'react-responsive';
import Popup from 'reactjs-popup';
import type { EventType, PopupPosition } from 'reactjs-popup/dist/types';

import { List } from 'reselect/es/types';

import Text from 'common/components/Text/Text';

import { useOnScrollEffect } from 'app/hooks';

import styles from './DetailInfo.module.scss';

interface CompProps {
  title: string | number;
  subtitle?: string | number;
  description?: string | number;
  icon?: any;
  className?: string;
  options?: List;
  many?: boolean;
  locations?: boolean;
  order?: boolean;
  scrollToStudyMode?: () => null;
  setSelectedCampus?: (city: number) => void;
}

const DetailInfo = (props: CompProps): React.ReactElement => {
  const {
    title,
    subtitle,
    description,
    icon,
    className,
    options,
    many,
    locations,
    order,
    scrollToStudyMode,
    setSelectedCampus,
  } = props;
  const [popupOpen, setPopupOpen] = useState<boolean>(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const popupProps = {
    position: ['bottom left'] as PopupPosition[],
    offsetY: 0,
    on: ['click'] as EventType[],
    arrow: false,
    keepTooltipInside: 'body',
  };

  const popupTrigger = (label: string, options: any) => (
    <div className={styles.title}>
      <button className={styles.multipleButton} onClick={() => setPopupOpen(true)}>
        {order ? (
          <Text size={isMobile ? 12 : 16} inline>
            From{' '}
            <Text size={isMobile ? 12 : 16} weight={700} inline>
              {options[0]}
            </Text>
          </Text>
        ) : (
          label
        )}
        <i className="bi bi-chevron-down"></i>
      </button>
    </div>
  );

  const selectOptionTrigger = (event: any) => {
    scrollToStudyMode?.();
    locations && setSelectedCampus?.(parseInt(event.currentTarget.id));
    setPopupOpen(false);
  };

  const handleScroll = useCallback(() => {
    setPopupOpen(false);
  }, []);

  useOnScrollEffect(handleScroll, ['detailContainer'], true);

  const selectBox = (
    <div className={styles.optionsBox}>
      <div className={styles.optionsLabels}>
        {options?.map((option: any, index: number) => (
          <div
            id={option[0]}
            className={styles.option}
            key={index}
            onClick={(event) => selectOptionTrigger(event)}
          >
            {locations ? option[1] : option}
          </div>
        ))}
      </div>
    </div>
  );
  return (
    <div className={`${styles.container} multipleContainer ${className}`}>
      {options ? (
        <div>
          <Popup {...popupProps} trigger={popupTrigger('Multiple', options)} open={popupOpen}>
            <div className={styles.optionsPopup}>{selectBox}</div>
          </Popup>
        </div>
      ) : (
        <div className={styles.title}>
          {many && <Text size={12}>From</Text>}
          {title}
        </div>
      )}
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {icon && <div className={styles.icon}>{icon}</div>}
    </div>
  );
};

export default DetailInfo;
